var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoMessageIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm0 22c-5.52 0-10-4.48-10-10S10.48 6 16 6s10 4.48 10 10-4.48 10-10 10z",
    fill: "#879494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.7c-.56 0-1 .44-1 1v6.8c0 .56.44 1 1 1s1-.44 1-1v-6.8c0-.54-.44-1-1-1zM16.02 9.6c-.52-.04-1 .5-1.02 1.04v.16c0 .54.42.94.98.96H16c.54 0 .98-.48 1-1v-.22c0-.58-.42-.94-.98-.94z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMessageIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/infoMessageIcon.ef24b0d5.svg";
export { MemoForwardRef as ReactComponent };